import React, { useEffect, useState } from "react";
import LoginFooter from "../AdminDashboard/LoginFooter/LoginFooter";
import DashboardNavbar from "../AdminDashboard/DashboardNavbar/DashboardNavbar";

const AdminLayout = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("isAdmin"));
    const hadndleIsAdmin = () => {
      setIsAdmin(true);
      // admin === true ? setIsAdmin(true) : setIsAdmin(false);
    };
    hadndleIsAdmin();
    //   console.log(localStorage.getItem("isAdmin"));
  }, []);
  return (
    <>
      {isAdmin && (
        <>
          <DashboardNavbar />
        </>
      )}
      <main>{children}</main>
      <LoginFooter />
    </>
  );
};

export default AdminLayout;
